/**
 * @generated SignedSource<<a735eb5f6aebf688f4843a5895652fbd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ExchangeAuthProviderRecoveryCodeInput = {
  code: string;
  email: string;
};
export type SSOLoginExchangeAuthProviderRecoveryCodeMutation$variables = {
  input: ExchangeAuthProviderRecoveryCodeInput;
};
export type SSOLoginExchangeAuthProviderRecoveryCodeMutation$data = {
  readonly exchangeAuthProviderRecoveryCode: {
    readonly data: boolean | null;
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type SSOLoginExchangeAuthProviderRecoveryCodeMutation = {
  response: SSOLoginExchangeAuthProviderRecoveryCodeMutation$data;
  variables: SSOLoginExchangeAuthProviderRecoveryCodeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ExchangeAuthProviderRecoveryCodeResponse",
    "kind": "LinkedField",
    "name": "exchangeAuthProviderRecoveryCode",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "data",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SSOLoginExchangeAuthProviderRecoveryCodeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SSOLoginExchangeAuthProviderRecoveryCodeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ac9efbfc4de2b6ba957946deedf656bb",
    "id": null,
    "metadata": {},
    "name": "SSOLoginExchangeAuthProviderRecoveryCodeMutation",
    "operationKind": "mutation",
    "text": "mutation SSOLoginExchangeAuthProviderRecoveryCodeMutation(\n  $input: ExchangeAuthProviderRecoveryCodeInput!\n) {\n  exchangeAuthProviderRecoveryCode(input: $input) {\n    data\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c83ef2db9b60c6edbb0e1f284fb20b84";

export default node;
